<script>
import { mapGetters } from "vuex";

import dateMixin from "@/mixins/dateMixin";
import addressMixin from "@/mixins/addressMixin";

import Modal from "@/components/_Shared/Modal/Index";
import Tip from "@/components/_base/Tip";

export default {
  mixins: [dateMixin, addressMixin],

  components: {
    Modal,
    Tip
  },

  methods: {
    day() {
      return this.$options.filters.formatDate(this.date, "DD/MM/YYYY (dddd)");
    },

    time() {
      return (this.initialHour < 10 ? "0" : "") + `${this.initialHour}h`;
    },

    hours() {
      return `${this.duration} hora` + (this.duration > 1 ? "s" : "");
    }
  },

  computed: {
    ...mapGetters("orderScheduler", [
      "date",
      "initialHour",
      "duration",
      "address"
    ])
  }
};
</script>

<template>
  <Modal>
    <template slot="header">
      <div class="header-text">Criar oferta de limpeza</div>
    </template>

    <template slot="body">
      <div class="city">
        <div class="name">{{ address | cityName }} - {{ address | stateCode }}</div>

        <div class="district">Bairro {{ address | districtName }}</div>
      </div>

      <div class="body-content">
        <div class="date">
          <img src="/static/calendar-outlined.svg" />
          <span>{{ day() }} - {{ time() }}</span>
        </div>

        <div class="duration">
          <img src="/static/clock-outlined.svg" />
          <span>{{ hours() }}</span>
        </div>

        <div class="location">
          <img src="/static/pin.svg" />
          <span>{{ address | name }}</span>
        </div>
      </div>
    </template>

    <template slot="footer">
      <Tip >
        Notificaremos todos os profissionais na sua cidade, inclusive aqueles que não possuem horários disponíveis. Os que desmonstrarem interesse serão exibidos e você poderá escolher o que mais lhe agradar.
      </Tip>
      <button class="btn bg-purple" @click="$emit('createOffer')">
        <span>Criar oferta</span>
      </button>

      <button class="btn bg-outlined" @click="$emit('closeOrderOfferModal')">
        <span>voltar</span>
      </button>
    </template>
  </Modal>
</template>

<style scoped>
.header-text {
  width: 100%;
  padding-bottom: 8px;
  text-align: center;
  font-weight: 400;
  border-bottom: solid 1px #e2e2e2;
}

.city {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #424242;
}

.city > .name {
  font-weight: 500;
  margin-bottom: 4px;
}

.city > .district {
  font-weight: 400;
  font-size: 14px;
}

.body-content {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
}

.body-content img {
  width: 14px;
  margin-right: 4px;
}

.date,
.duration,
.location {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 13px;
}

/* .filters {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #e2e2e2;
  border-radius: 2px;
  padding: 4px;
  margin-bottom: 8px;
}

.dtd {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.date,
.duration,
.time,
.professional-name {
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-size: 14px;
  color: #424242;
  font-weight: 400;
  text-align: center;
  background: #fff;
  border: solid 2px #e2e2e2;
  transition: border-color 250ms ease-in-out;
}

.date,
.duration {
  width: 30%;
}

.time {
  width: 40%;
  margin: 0 2px;
}

.professional-name {
  margin-top: 2px;
  width: 100%;
}

.selected {
  border: solid 2px #603285;
}

.name {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

img {
  height: 16px;
  width: 16px;
  margin-right: 4px;
}

.picker {
  display: flex;
  height: 100%;
}

b {
  font-weight: 400;
  color: #af006b;
}
 */
button {
  margin: 0;
  margin-top: 8px;
}

.bg-outlined {
  padding: 8px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalOfferList/OrderOffer.vue